export default __webpack_public_path__ + "static/media/xmati.6b5ecad3.png";